import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=9814d676&scoped=true&"
import script from "./base-button.vue?vue&type=script&lang=js&"
export * from "./base-button.vue?vue&type=script&lang=js&"
import style0 from "./base-button.vue?vue&type=style&index=0&id=9814d676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9814d676",
  null
  
)

export default component.exports